import React from 'react';
import MessageBox from './MessageBox';

const errorContext = React.createContext(() => {});
export const useErrorContext = () => React.useContext(errorContext);





const ErrorBox = ({children}) => {   
    const [errorCheckItems, setCheckErrorItems] = React.useState([]);

    const handleOnClose = () => {
      }

    return (
        <errorContext.Provider value={setCheckErrorItems}>            
            {errorCheckItems.map((item, index) => {                
                if ((item != null) && (item.error != undefined)){
                    // console.log("ERROR:",item.error);
                    let error = item.error;
                    return (<MessageBox key={index} messageHeader={error.message} messageBody={error.detail} messageType="error"  />); //onClose={handleOnClose}
                }                 
                return (null);
            })}            
            {children}
        </errorContext.Provider>
      );
};

export default ErrorBox;
